export const Usuarios = {
  ID: "ID",
  NOME: "Nome",
  USUARIO: "Usuário",
  NOME_COMPLETO: "Nome Completo",
  SOBRENOME: "Sobrenome",
  NACIONALIDADE: "Nacionalidade",
  SENHA: "Senha",
  CONFIRMACAO_SENHA: "Confirmação da Senha",
  PASSAPORTE: "Passaporte",
  CPF_CNPJ: "CPF / CNPJ",
  CPF: "CPF",
  CNPJ: "CNPJ",
  RG: "RG",
  EMAIL: "E-mail",
  TELEFONE: "Telefone",
  TITULACAO: "Titulação",
  DATA_NASCIMENTO: "Data de Nascimento",
  ENDERECO: "Endereço",
  CONFIRMAR_EXCLUIR: "Tem certeza que deseja excluir o usuário {nome}?",
  MENSAGEM_EXCLUIDO: "Usuário excluído com sucesso.",
  MENSAGEM_CADASTRADO: "Usuário cadastrado com sucesso",
  MENSAGEM_ATUALIZADO: "Usuário atualizado com sucesso",
  DADOS_PESSOAIS: "Dados Pessoais",
  LOGRADOURO: "Logradouro",
  NUMERO: "Número",
  CEP: "Cep",
  COMPLEMENTO: "Complemento",
  BAIRRO: "Bairro",
  CIDADE_NOME: "Cidade",
  ESTADO_NOME: "Estado",
  DADOS_ACESSO: "Dados de Acesso",
  USUARIO_REPROVADO: "Usuário reprovado para acesso",
  CELULAR: "Celular",
  NOME_EMPRESA: "Empresa",
};
